import { IStoryContent, IMergeTag, IMergeTags, IStoryMergeTags, IStoryMergeTag } from '@opengov/stories-shared/types';
import React, { createContext, useMemo } from 'react';
import { values } from 'lodash';
import { getSortedMergeTagsList, getStoryMergeTags } from './mergeTagsContextUtils';

interface MergeTagsContextProps {
  mergeTags: IMergeTags | null;
  mergeTagList: IMergeTag[] | [];
  storyMergeTags: IStoryMergeTags;
  storyMergeTagList: IStoryMergeTag[];
  loadingMergeTags: boolean;
}

export const MergeTagsContext = createContext<MergeTagsContextProps | undefined>(undefined);

export const MergeTagsProvider = ({
  children,
  mergeTags,
  storyContents,
  canAddProposalContent,
  loadingMergeTags = false
}: {
  children: React.ReactNode;
  mergeTags: IMergeTags;
  storyContents: IStoryContent[];
  canAddProposalContent: boolean;
  loadingMergeTags?: boolean;
}) => {
  const mergeTagList = useMemo(() => {
    return mergeTags ? getSortedMergeTagsList(mergeTags) : [];
  }, [mergeTags]);
  const storyMergeTags = useMemo(() => {
    if (!canAddProposalContent) return {};
    const allContents = storyContents.reduce((acc, storyContent) => `${acc}${storyContent.content}`, ``);
    return getStoryMergeTags(allContents, mergeTags || {});
  }, [canAddProposalContent, mergeTags, storyContents]);
  const storyMergeTagList = useMemo(() => {
    return storyMergeTags ? values(storyMergeTags) : [];
  }, [storyMergeTags]);

  return (
    <MergeTagsContext.Provider value={{ mergeTags, mergeTagList, storyMergeTags, storyMergeTagList, loadingMergeTags }}>
      {children}
    </MergeTagsContext.Provider>
  );
};
